import { FC } from 'react';

import DividendsSection from './components/DividendsSection';
import OperationsSection from './components/OperationsSection';

import './PartnerOperations.scss';

const PartnerOperations: FC = () => (
  <>
    <OperationsSection />
    <DividendsSection />
  </>
);

export default PartnerOperations;
